import styled from 'styled-components';

interface WrapperProps {
	variant?: 'medium' | 'large';
	disabled?: boolean;
	renderBorder?: boolean;
}

export const Wrapper = styled.div<WrapperProps>`
	--_font-size: ${({ variant }) => (variant === 'medium' ? '13px' : '16px')};

	--_padding-inline: var(
		--input-padding-inline,
		${({ variant }) => (variant === 'medium' ? '8px' : '12px')}
	);
	--_padding-block: var(
		--input-padding-block,
		${({ variant }) => (variant === 'medium' ? '6px' : '9px')}
	);
	--_border-color: ${({ theme }) => theme.gray['200']};
	--_border-width: ${({ renderBorder }) => (renderBorder ? '1px' : '0')};
	display: var(--input-display, block);

	position: relative;
	width: auto;

	border-radius: var(--input-border-radius, 2px);
	background: var(
		--input-background,
		${({ theme, disabled }) => (disabled ? 'transparent' : theme.gray['100'])}
	);
`;

// Both the field and sizer share these styles
export const Shared = styled.div<{ readonly?: boolean }>`
	font-family: var(--input-font, Inter);
	font-size: var(--input-font-size, var(--_font-size));
	box-sizing: border-box;
	margin: 0;
	word-break: break-word; // Same as a <textarea>
	white-space: pre-wrap; // Same as a <textarea>
	width: 100%;

	color: var(
		--input-color,
		${({ theme, readonly }) => (readonly ? theme.gray['600'] : theme.gray['1000'])}
	);
	border-width: var(--_border-width);
	border-style: solid;
	border-color: var(--input-border-color, ${({ theme }) => theme.gray['200']});
	border-radius: var(--input-border-radius, 2px);
	padding-inline: var(--_padding-inline);
	padding-block: var(--_padding-block);
	line-height: var(--input-line-height, 1.4);

	:hover {
		border-color: var(--input-border-color-hover, var(--_border-color));
	}
`;

// This is expected to be a <textarea>, but that is not enforced here.
// It should be used with an as="textarea" prop.
export const Field = styled(Shared)`
	// <textarea> stuff
	outline: none;
	resize: none;
	background-color: transparent;
	overflow: hidden; // Prevent scrolling in edge cases
	caret-color: var(--input-caret-color, ${({ theme }) => theme.gray['1000']});

	position: absolute;
	top: 0;
	left: 0;
	height: 100%;

	:focus {
		border-color: var(--input-border-color-focus, var(--_border-color));
	}

	::placeholder {
		color: ${({ theme }) => theme.gray['700']};
		font-weight: 300;
		font-style: italic;
	}
`;

interface SizerProps {
	minLines: number;
}

export const Sizer = styled(Shared)<SizerProps>`
	position: relative;

	min-height: calc(${(p) => p.minLines}em * 1.4 + 2 * var(--_padding-block) + 2px);

	// This is layered on top of the <textarea>, so clicks need to be ignored
	// so they will go down to the <textarea>.
	pointer-events: none;

	// Allow the <textarea> to be be the thing that handles the border color on
	// focus (<div>s don't get focus).
	border-color: transparent;
`;
